<template>
    <div class="dowsing-animation-stage">
        <svg id="dowsing-anim" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 263.56 363.65">
            <g id="bobbles">
                <path d="M243.09,92.59l-4.45,15.3-4.45-15.3c-.73-2.5-2.68-4.45-5.17-5.17l-15.3-4.45,15.3-4.45c2.5-.73,4.45-2.68,5.17-5.17l4.45-29.86,4.45,29.86c.73,2.5,2.68,4.45,5.17,5.17l15.3,4.45-15.3,4.45c-2.5.73-4.45,2.68-5.17,5.17Z" />
                <path d="M29.36,178.47l-4.45,15.3-4.45-15.3c-.73-2.5-2.68-4.45-5.17-5.17l-15.3-4.45,15.3-4.45c2.5-.73,4.45-2.68,5.17-5.17l4.45-29.86,4.45,29.86c.73,2.5,2.68,4.45,5.17,5.17l15.3,4.45-15.3,4.45c-2.5.73-4.45,2.68-5.17,5.17Z" />
                <path d="M19.92,35.34l-2.37,8.15-2.37-8.15c-.39-1.33-1.43-2.37-2.76-2.76l-8.15-2.37,8.15-2.37c1.33-.39,2.37-1.43,2.76-2.76l2.37-15.9,2.37,15.9c.39,1.33,1.43,2.37,2.76,2.76l8.15,2.37-8.15,2.37c-1.33.39-2.37,1.43-2.76,2.76Z" />
                <path d="M218.54,178.51l-2.37,8.15-2.37-8.15c-.39-1.33-1.43-2.37-2.76-2.76l-8.15-2.37,8.15-2.37c1.33-.39,2.37-1.43,2.76-2.76l2.37-15.9,2.37,15.9c.39,1.33,1.43,2.37,2.76,2.76l8.15,2.37-8.15,2.37c-1.33.39-2.37,1.43-2.76,2.76Z" />
                <path d="M55.92,245.75l-2.37,8.15-2.37-8.15c-.39-1.33-1.43-2.37-2.76-2.76l-8.15-2.37,8.15-2.37c1.33-.39,2.37-1.43,2.76-2.76l2.37-15.9,2.37,15.9c.39,1.33,1.43,2.37,2.76,2.76l8.15,2.37-8.15,2.37c-1.33.39-2.37,1.43-2.76,2.76Z" />
                <circle cx="49.23" cy="94.03" r="4.32" />
                <circle cx="185.32" cy="26.34" r="4.32" />
                <circle cx="188.34" cy="141.78" r="4.32" />
                <circle cx="147.97" cy="265.97" r="4.32" />
            </g>
            <g id="hand-stick">
                <path
                    d="M123.7,62.45c1.49,1.53-.12,10.68-.61,13.13-.31,1.55-.87,4.6-1.3,5.86-.76,2.27-3.57,3.46-3.7,6.93-.09,2.48,1.45,3.54,2.05,5.41.46,1.45.05,7.52,3.69,5.86,1.84-.84,7.39-9.39,8.09-11.64.76-2.45.97-12.02,4.11-11.36,3.2,6.84,1.72,14.62-2.4,20.83-3.72,5.62-10.72,8.48-9.79,16.18-1.73-.79-2.45-3.38-4.76-2.98-.1,1.6,2.14,2.2,2.87,3.36,2.37,3.74.23,6.66.08,10.65-.15,3.95-.58,20.76,1.51,23.05l2.69.27c-.68,2.54-2.92,5.26-5.42,2.88l-.56-4.38c-4.93,3.4,2.51,9.81,6.22,4.74l2.72-5.33c.44,4.91-2.46,7.75-5.96,10.45,2.61.98,5.85-3.23,6.58-5.35.79-2.27.19-4.14.69-5.88.28-.98,2.57-2.58,3.39-4.37.96-2.09,1.51-8.48,2.76-9.19.23-.13.98-.15.88.29-1.27,1.14-1.7,3.59-1.62,5.22.12,2.67,2.34,5.07,2.22,6.69-.06.84-1.82,3.89-2.4,4.81-2.57,4.11-10.3,10.81-11.73,14.53-1.21,3.15-.92,8.88-.8,12.39.07,2.29,2.09,5.83-1.16,6.26v.88c11.66,7.23,20.08,17.35,24.4,30.51,2.58,7.87,3.19,18.59,6.48,25.76,1.33,2.89,6.62,9.75,8.8,12.69,3.79,5.11,8.28,9.73,11.95,14.94l-.04.64c-6.75,6.19-12.86,13.24-15.83,22.09l-1.23-.38c-6.41-8.19-13.37-17.16-22.99-21.63-3.16-1.47-8.92-2.52-11.13-3.78-.57-.33-.88-.61-1.17-1.22-.42-.88-1-8.61-1.05-10.29-.08-2.41-.94-7.63,2.03-7.46,5.88.33,7.15,1.72,5.75-6,4.2.5,6.16-.53,5.33-5.05-.26-1.4-1.61-2.55-1.73-4.29-.18-2.57,1.12-4.7.32-8.03-.81-3.33-5.85-5.94-7.8-8.91-1.73-.66.46,2.65-2.83,1.65-1.1-.33-5.72-4.34-6.12-5.26-.66-1.5.85-3.88.72-5.57-.2-2.63-4.32-6.65-2.79-10.52,1.55-.36,1.04.46,1.53,1.13,1,1.34,3.51,7.46,5.02,6.03.16-.85-.18-1.47-.46-2.22-2.78-7.39-14.82-11.62-19.32-20.07-1.16-2.18-4.41-10.11.57-8.96s11.98,8.39,16.65,10.88c3.32.87,1.87-5.28,1.94-7.42.05-1.52.71-2.92.61-4.45-2.75,1.7-2.47,7.36-1.79,10.15-1.96-.81-3.78-2.28-4.13-4.51-.93-5.89-.58-31.72.84-37.31.91-3.58,5.48-7.54,6.48-10.82,1.5-4.88.25-11.85-6.16-9.46l4.46,1.79c1.49,2.21,1.05,5.05.33,7.48-.17.58-1.04,2.59-1.81,2.66.29-2.46,2.1-3.83.87-6.56-.48-1.06-3.58-3.09-4.76-1.8.5,2.01,3.71.65,3.91,3.32.07.92-2.48,6.67-3.6,5.64,2.3-4.04-4.4-8.19-4.69-9.36-.34-1.38,1.16-3.89.19-6.74-.26-.76-3.05-4.39-3.84-3.61.25,2.01,2.57,3.04,2.95,5.11.27,1.45.36,4-1.76,3.85.67-2.27,1.01-5.92-1.78-6.57l1.1,3.38-1.1.8-2.4-6.28,1.18-.29-1.19-2.09c3.47-5.1,4.45.15,6.32,2.64.96,1.27,4.4,5.31,5.94,3.06,1.17-1.71-.13-20.97-.07-24.55,2.43-6.13,8.37-11.2,7.81-18.51-.21-2.75-2.06-4.46-2.11-7.14.85-.04,2.25.14,2.83.74ZM133.97,89.18c-1.06,1.39-3.33,3.2-4.17,4.48-.53.81-.47,1.47.3,1.48,1.44.02,4.71-4.1,3.87-5.96ZM118.48,138.76c-1.18-.22-1.45.54-1.84,1.44-1,2.34-1.77,6.76-1.74,9.3,1.7.31.98-.41,1.34-1.31,1.21-3,1.22-6.36,2.23-9.43ZM116.1,170.41c2.23-2.06,1.68-6.26,1.78-8.96-.84-.14-.86,1.06-1.01,1.66-.56,2.24-.8,4.98-.76,7.3ZM121.46,208.63c-.14-1.75.13-5.86-2.38-5.97-.13,1.25,0,2.37.29,3.6.18.75.8,2.84,2.09,2.37ZM141.13,238.5c-1.78-2.1-2.53,8.48-2.98,8.96l-4.16-2.39,1.79,4.77c-1.63.38-7.71.19-8.34,1.5-.52,1.07,1.13,1.05,1.77,1.19,2.14.46,4.41.57,6.57.9l-2.38,4.77,4.76-2.38,1.8,8.96c1.58.15.97.03,1.17-.9.55-2.44,1.33-4.92,1.21-7.46l4.76,2.39-2.09-4.78,8.65-2.1c.48-1-1.02-1.18-1.64-1.31-2.21-.49-4.92-.15-7-1.36-1.11-1.44,2.51-2.51,2.09-4.19l-4.76,2.39-1.2-8.96Z"
                />
                <path
                    d="M109.54,254.92c.02.17.9.67.6.89-1.09.14-1.77,0-2.72-.56-1.61-.94-7.77-6.7-9.52-8.38-3.36-3.2-7.84-6.81-7.43-11.96,7.25,1.57-.39-2.51-1.23-3.85-1.65-2.61-.93-9.43,2.43-8.47,1.68.48,6.01,3.81,7.64,5.08,4.07,3.85,25.54,8.47,27.23,12,.54,1.12.27,2.42.3,3.59-1.68.32-7.07-.87-7.67.98-.39,5.56-.85,11.07-.7,16.67.1,3.6,2,8.89.02,11.93-.11.34,1.07.18,1.2.67.72,2.63-3.7,8.94-4.61,12.02-1.43,4.81-1.64,11.71.69,16.3.75,1.48,1.96,3.25,3.91,2.95-.94-2.25-2.61-4.07-3.28-6.56-.87-3.22-.92-7.67-.14-10.91.32-1.34,2.48-7.06,3.13-8.22.16-.29.77-.77.89-.59-.13,3.07.19,6.21.03,9.28-.2,3.8-2.61,9.02.87,11.61.98-1.24,2.52-1.82,3.54-3.01,3-3.52,3.2-10.64,8.08-11.31,2.35,1.6-2.72,14.28-3.88,16.71-1.67,3.51-3.89,6.71-8.12,7.39-2.46.4-3.61-1.25-5.87-1.4.95,4.06,6.46,3.02,9.54,2.39-3.92,5.37-6.7,12.75-7.14,19.41-.64,9.57,3.63,20.93,2.32,30.4-.15,1.09-.73,3.14-1.73,3.66l-3.58-.33c-.21-.29,1.21-3.48,1.56-4.11.19-.35,5.01-5.93,2.33-4.84-1.48.6-5.38,6.37-5.08,8.36-.63.2-1.69-.44-1.79-.91-.17-.85,7.02-9.22,5.07-12.24-1.24,4.05-3.52,7.18-5.67,10.75l-1.5-.57c-1.48-2.25,1.9-3.96,2.65-5.28,1.1-1.96,2.25-4.74,2.46-6.96.28-2.9.67-8.63-1.81-10.47,1.28,6.69,1.06,12.27-2.99,17.91l-1.18-5.68c-.67-14.74,3.62-32.8,1.74-47.12-1.44-10.96-14.57-17.11-14.3-28.13.06-2.51.61-5.27,3.61-5.07,1.3,6.16,1.7,12.2,7.45,15.95,6.99-4.57-.73-14.69,7.46-19.25-.52-2.81-2.93,1.43-4.16,1.5-.39-3.46,3.27-3.94,4.17-6.56l-4.17,1.49,4.18-4.78-3.58,1.49.58-14.93,2.38-.88-8.34-2.09c.63,1.69,4.17,1.23,4.17,3.28,0,3.22-.41,7.76,0,10.75ZM101.78,283.29c-1.49-3.45-2.48-7.86-4.76-10.75-.02,1.25-.13,2.5.13,3.74.17.8,3.36,8.37,4.63,7ZM116.1,276.13c-1.46,3.38-3.89,6.76-4.88,10.35-.32,1.16-1.99,8.71-.2,8.75,1.33-2.29.96-5.11,1.66-7.88.83-3.25,2.91-6.95,4.3-10.05l-.89-1.18Z"
                />
                <path
                    d="M99.05,179.12c2.12,2.31,13.72,19.95,14.37,22.32.56,2.02.27,3.46-.32,5.4-7.46-4.19,2.43,5.48,4.04,6.55,5.5,3.66,15.18,2.9,13.79,13.1-.78,1.3-7.14-2.18-8.73-2.77-9.76-3.59-14.73-5.64-23.08-12.11-5.15-3.99-11.86-7.93-10.44-15.2,1.32-6.75,10.92,2.38,11.91,1.48-2.23-3.73-8.49-6.88-8.79-11.79-.16-2.53,1.94-9.98,5.4-9.04.87.24,1.25,1.42,1.85,2.08Z"
                />
                <path d="M95.01,210.04c.91.86,1.44,2.41,2.47,3.37,3.16,2.96,12.96,8.67,17.1,10.17,7.61,2.77,15.89,2.15,17.61,12.52-8.95,0-19.77-3.71-27.83-7.66-4.25-2.08-12.51-6.53-13.94-11.12-1.23-3.96-.16-11.77,4.59-7.29Z" />
                <path
                    d="M117.63,79.98c-.28.44-1.43.6-.94,2.03-1.01.04-1.3.32-1.17-.86.38-3.31,2.62-4.38,3.74-7.02.35-.83,2.02-5.42-.17-4.66-.42.45-.28,6.43-2.38,5.09,1.3-1.53.89-3.54,1.34-5.22.23-.86,1.13-1.46,1.39-2.25.37-1.11-.8-2.52.83-2.98,2.72,5.23.28,11.26-2.63,15.88Z"
                />
                <path d="M139.34,141.14l-1.82-4.48,1.24-5.67c1,0,1.13,1.99,1.19,2.68.2,2.63-.28,4.92-.6,7.47Z" />
            </g>
            <g id="hoops">
                <circle id="hoop-1" class="wand-anim-3 wand-circ" style="animation-delay: 0.4s" cx="119.03" cy="101.68" r="41.87" />
                <circle id="hoop-2" class="wand-anim-4 wand-circ" style="animation-delay: 0.6s" cx="119.03" cy="101.68" r="48.44" />
                <circle id="hoop-3" class="wand-anim-8 wand-circ" style="animation-delay: 1.4s" cx="119.03" cy="101.68" r="55.01" />
                <circle id="hoop-4" class="wand-anim-5 wand-circ" style="animation-delay: 0.8s" cx="119.03" cy="101.68" r="61.58" />
                <circle id="hoop-5" class="wand-anim-10 wand-circ" style="animation-delay: 1.8s" cx="119.03" cy="101.68" r="68.15" />
                <circle id="hoop-6" class="wand-anim-1 wand-circ" style="animation-delay: 0s" cx="119.03" cy="101.68" r="74.72" />
                <circle id="hoop-7" class="wand-anim-6 wand-circ" style="animation-delay: 1s" cx="119.03" cy="101.68" r="81.28" />
                <circle id="hoop-8" class="wand-anim-7 wand-circ" style="animation-delay: 1.2s" cx="119.03" cy="101.68" r="87.85" />
                <circle id="hoop-9" class="wand-anim-9 wand-circ" style="animation-delay: 1.6s" cx="119.03" cy="101.68" r="94.42" />
                <circle id="hoop-10" class="wand-anim-2 wand-circ" style="animation-delay: 0.2s" cx="119.03" cy="101.68" r="100.99" />
            </g>
            <path id="snake" d="M204.74,146.23c-20.55-20.97-65-4.19-80.94,7.13-15.94,11.32-28.94,4.61-28.94,4.61,0,0-10.9-9.65,19.29-24.32,22.83-11.1,20.01-37.3,17.27-49.42,3.67-3.48,6.1-9.49,6.1-16.33,0-7.86-3.21-14.62-7.82-17.7-.45-3.84-2.6-6.78-5.25-7.06.04-1.79-.39-4.29-.66-5.7,1.99-.56,3.33-3.11,2.45-5.08.22,1.94-1.39,3.77-3.22,4.12-.01,0-.02,0-.04-.01,0,0,0,.01,0,.02-.46.08-.93.07-1.38-.06-.57-1.3-1.15-2.6-1.97-3.87-.84,2.2,1.02,4.96,3.32,4.99-.06,1.5-.17,3.97-.03,5.7-2.35.69-4.17,3.5-4.56,7.04-4.54,3.13-7.68,9.83-7.68,17.61,0,8.44,3.7,15.61,8.86,18.32,1.77,8.84,2.8,28.24-18.82,37.78-28.52,12.58-35.65,21.39-31.45,39.84,4.19,18.45,16.36,26.42,29.78,23.9,12.47-2.34,61.46-30.34,83.83-23.56,8.35.77,14.9,7.79,14.9,16.35,0,9.07-7.35,16.42-16.42,16.42-.54,0-1.07-.03-1.6-.08-3.84,1.14-11.79,1.34-28.29-2.83-31.45-7.97-42.78-4.61-42.78-4.61,0,0-41.52-1.26-53.26,45.29-11.74,46.55,43.2,40.26,49.91,31.03,6.71-9.23,15.2-41.94,32.14-34.81,16.93,7.13,12.84,17.19,0,23.07-12.84,5.87-38.01,14.68-23.33,45.71,0,0,5.87,9.23,15.52,11.32,0,0-25.58-33.97-1.68-42.36,23.9-8.39,41.94-20.55,28.1-43.62-2.5-4.17-5.63-7.04-9.1-8.91,14.02,5.14,33.75,10.27,50.2,2.2,23.07-11.32,28.1-51.17,7.55-72.13ZM117.07,69.34c-1.25-3.99.97-8.24,4.96-9.49,2.12-.66,4.31-.34,6.08.7-1.16-.32-2.43-.33-3.67.06-3.41,1.07-5.3,4.69-4.23,8.1,1.07,3.41,4.69,5.3,8.1,4.23.55-.17,1.06-.42,1.53-.72-.87.94-1.98,1.67-3.28,2.08-3.99,1.25-8.24-.97-9.49-4.96ZM80.62,164.11c-2.65,0-4.8-2.15-4.8-4.8s2.15-4.8,4.8-4.8,4.8,2.15,4.8,4.8-2.15,4.8-4.8,4.8ZM184.96,153.49c-2.65,0-4.8-2.15-4.8-4.8s2.15-4.8,4.8-4.8,4.8,2.15,4.8,4.8-2.15,4.8-4.8,4.8ZM99.26,195.27c2.26,0,4.1,1.83,4.1,4.1s-1.83,4.1-4.1,4.1-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1ZM73.1,265.32c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1ZM106.6,231.78c-2.52,13.84-9.1,34.41-30.62,20.97-21.52-13.44,12.58-42.36,23.49-43.2s22.81-2.98,33.97,1.26c2.15.82,4.99,2.02,8.33,3.35-15.08-3.75-33.33,7.49-35.17,17.62ZM139.47,225.89c-1.59,0-2.88-1.29-2.88-2.88s1.29-2.88,2.88-2.88,2.88,1.29,2.88,2.88-1.29,2.88-2.88,2.88ZM182.3,213.07c-2.65,0-4.8-2.15-4.8-4.8s2.15-4.8,4.8-4.8,4.8,2.15,4.8,4.8-2.15,4.8-4.8,4.8Z"/>
        </svg>
    </div>
</template>
<script>
export default {
    name: 'wand-animation',
    methods: {
        getRandomInt(max) {
            return Math.floor(Math.random() * max);
        }
    }
}
</script>

<style>
@keyframes hover {
    from {
        transform: translateY(-6px) scale(0.7);
        opacity: 0.7;
    }
    to {
        transform: translateY(6px) scale(0.7);
        opacity: 0.7;
    }
}

@keyframes blip {
    from {
        opacity: 0;
    }
    to {
        opacity: 0.7;
    }
}

.dowsing-animation-stage * {
    fill: var(--the-yellow);
    transition: all 0.2s;
    width: 250px;
    margin: 0 auto;
}

.wand-anim-1 {
	stroke-width: 1.63px;
}

.wand-anim-1,
.wand-anim-2,
.wand-anim-3,
.wand-anim-4,
.wand-anim-5,
.wand-anim-6,
.wand-anim-7,
.wand-anim-8,
.wand-anim-9,
.wand-anim-10 {
	fill: none;
	stroke: var(--the-yellow);
	stroke-miterlimit: 10;
}

.wand-anim-2 {
	stroke-width: 1.47px;
}

.wand-anim-3 {
	stroke-width: 1.78px;
}

.wand-anim-4 {
	stroke-width: 1.94px;
}

.wand-anim-5 {
	stroke-width: 1.16px;
}

.wand-anim-7 {
	stroke-width: 1.31px;
}

.wand-anim-8 {
	stroke-width: 2.1px;
}

.wand-anim-9 {
	stroke-width: 2.26px;
}

.wand-anim-10 {
	stroke-width: 2.41px;
}

.wand-circ {
    opacity: 0;
}

#hand-stick {
    animation: hover 2s infinite alternate;
    opacity: 0.7;
    transform: scale(0.4);
    transform-origin: center;
}

.dowsing-animation-stage #bobbles {
    
}

.dowsing-animation-stage #bobbles path {
    display: none;
}

.dowsing-animation-stage #bobbles circle {
    animation: wobble 1s infinite alternate;
    fill: var(--the-yellow);
}

.dowsing-animation-stage:hover #bobbles circle {
    animation: none;
    opacity: 0;
}

.dowsing-animation-stage:hover .wand-circ {
    animation: blip 1s infinite forwards;
}

.dowsing-animation-stage:hover #hand-stick {
    animation: none;
    opacity: 1;
    transform: scale(0.9);
}

@keyframes swell {
    from {
        transform: 0.9;
    }
    to {
        transform: scale(1.2);
    }
}

#snake {
    fill: transparent;
    stroke: var(--the-yellow);
    stroke-width: 0.3px;
    opacity: 0.8;
    animation: swell 3s infinite alternate;
    transform-origin: center;
    margin-bottom: -1rem;
}

.dowsing-animation-stage:hover #snake {
    opacity: 0;
}

#dowsing-anim {
    overflow: visible;
}
</style>